import React, { useState, useEffect, useRef } from "react";
// import { handleGetRequest } from "../../../services/GetTemplate";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useHistory } from "react-router-dom";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";

function BankBranchManagement() {
    const [group, setGroup] = useState([]);
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [selectedCustomers, setSelectedCustomers] = useState(null);
    const [displaySubDetailsModal, setDisplaySubDetailsModal] = useState(false);
    const [status, setstatus] = useState(false);
    const [checked2, setChecked2] = useState(true);
    const [visible, setVisible] = useState(false);

    // useEffect(() => {
    //     const getGroup = async () => {
    //         setloading(true);
    //         // const response = await handleGetRequest("zbiz/fin/branchAuth/fetchAllPendingAuthTransactions");
    //         setGroup(response?.data);
    //         setloading(false);
    //     };
    //     getGroup();
    // }, []);

    let history = useHistory();

    const myData = [
        {
            branchName: "Js Bank Limited",
            branchCode: "Shaheen Complex",
            bankCode: 9001,
            cityId: 111,
            phoneNo1: 104322323,
            phoneNo2: 104322323,
            address: "--",
            email: "ahmed@gmail.com",
        },
        {
            branchName: "UBL",
            branchCode: "I.I.Chundrigar",
            bankCode: 9002,
            cityId: 212,
            phoneNo1: 104322323,
            phoneNo2: 104322323,
            address: "--",
            email: "ahmed@gmail.com",
        },
    ];

    const actionTemplate = () => {
        return (
            <div>
                <i className="pi pi-tag" onClick={(e) => history.push("/editbankbranchmanagement")}></i>
                <i className="pi pi-trash" onClick={confirm1}></i>
            </div>
        );
    };

    const confirm1 = () => {
        confirmDialog({
            message: "Are you sure you want to Delete this?",
            icon: "pi pi-trash",
            acceptLabel: "ok",
            rejectLabel: "cancel",
            accept,
            reject,
        });
    };

    const accept = () => {
        console.log("value is accepted");
    };

    const reject = () => {
        console.log("value is rejected");
    };

    const bulkClicked = () => {
        history.push("/addbulkbranch");
    };

    return (
        <>
            <div className="card p-datatable-sm">
                <DataTable header="Bank Branch List" value={myData} loading={loading} selection={selectedCustomers} onSelectionChange={(e) => setSelectedCustomers(e.value)} paginator rows={6} emptyMessage="No data found.">
                    <Column selectionMode="multiple" headerStyle={{ width: "3em" }}></Column>
                    <Column filter field="branchCode" header="Branch Code" />
                    <Column filter field="branchName" header="Branch Name" />
                    <Column filter field="bankCode" header="Bank Code" />
                    <Column filter field="cityId" header="City ID" />
                    <Column filter field="phoneNo1" header="Phone No 1" />
                    <Column filter field="phoneNo2" header="Phone No 2" />
                    <Column filter field="address" header="Address" />
                    <Column filter field="email" header="Email" />
                    <Column filter field="address" header="Description" />
                    <Column filter field="address" header="Is Branch" />
                    <Column filter field="address" header="Is Printing Location" />
                </DataTable>
            </div>
            <div className="Down__Btn">
                <Button label="Cancel" onClick={confirm1} className="Btn__Transparent" />
                <Button disabled={loading} label="Add Branch" className="Btn__Dark" />
            </div>
        </>
    );
}

export default BankBranchManagement;
